import * as THREE from "three";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

const SphereModel = {
  id: "sphere",

  name: "Sphere",

  type: "procedural",

  createGeometry() {
    const geometry = new THREE.SphereGeometry(1.35, 128, 64);

    return computeCurvatureDirections(geometry);
  },

  transform: {
    scale: 1.0,

    rotation: [0, 0, 0],
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },
};

export default SphereModel;
